import {
	CLASSIC_BOARD,
	COMPANY_MANAGED_BOARD,
} from '@jira/platform__observability-capabilities/src/constants.tsx';

export const classicBoardCapability: 'COMPANY_MANAGED_BOARD' | 'CLASSIC_BOARD' = !__SERVER__
	? COMPANY_MANAGED_BOARD
	: CLASSIC_BOARD;
